( function( app ) {
  const COMPONENT = {
    init: function() {
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'ripped-paper-transition', COMPONENT );
} )( app );
